<script setup lang="ts">
import locations from '@/scripts/locations';

/**
 * Strip non-digits from a phone string for a `tel:` href (e.g. "(219) 872-0571" → "+12198720571").
 */
function telHref(phone: string): string {
  return `tel:+1${phone.replace(/\D/g, '')}`;
}
</script>

<template>
  <footer>
    <div class="bg-brand-dark-red h-40" />
    <div class="h-3 bg-white" />
    <div class="bg-brand-green grid grid-cols-1 pb-30 text-center sm:grid-cols-3 md:px-30 lg:px-60">
      <div
        v-for="loc in locations"
        :key="loc.name"
        class="flex flex-col sm:-mt-65 [&_a]:text-white [&_a]:no-underline [&_a]:hover:underline"
      >
        <h3 class="text-16 pb-10 font-bold text-white lg:pb-15">{{ loc.name }}</h3>
        <a :href="loc.mapUrl" target="_blank" rel="noopener">
          {{ loc.address }}
          <span class="sr-only"> (opens in new tab)</span>
        </a>
        <a :href="telHref(loc.phone)">{{ loc.phone }}</a>
      </div>
    </div>
  </footer>
</template>
